// ─────────────────────────────────────────────
//  Avatar — the round user circle in the topbar.
//  Doctors show their short code; everyone else shows first+last initials.
//  When given an onClick it renders as a button (keyboard-focusable) that the
//  caller wires to the profile page.
// ─────────────────────────────────────────────
import React from "react";
import { avatarText } from "../domain/avatar";
import tokens from "../theme/tokens";

const { color, font } = tokens;

export default function Avatar({ user, isDoctor, onClick, size = 32, title = "Edit your profile" }) {
  const text = avatarText(user, isDoctor);
  const style = {
    width: size,
    height: size,
    borderRadius: "50%",
    background: color.accent.primary,
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: font.weight.bold,
    fontSize: font.size.label,
    border: "none",
    padding: 0,
    cursor: onClick ? "pointer" : "default",
  };

  if (!onClick) return <div style={style}>{text}</div>;

  return (
    <button type="button" style={style} onClick={onClick} title={title} aria-label={title}>
      {text}
    </button>
  );
}
